"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hearingContract = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@ts-rest/core");
const zod_1 = tslib_1.__importDefault(require("zod"));
const resources_1 = require("./resources");
const c = (0, core_1.initContract)();
const path = '/hearing';
exports.hearingContract = c.router({
    getHearing: {
        method: 'GET',
        path: `${path}/:hearingId`,
        headers: resources_1.UserAuthHeadersSchema,
        responses: {
            [200]: resources_1.Hearing,
        },
        pathParams: zod_1.default.object({ hearingId: zod_1.default.string().uuid() }),
        summary: 'Retrieve a single hearing for a court system',
    },
    updateHearing: {
        method: 'PUT',
        path: `${path}/:hearingId`,
        headers: resources_1.UserAuthHeadersSchema,
        responses: {
            [200]: resources_1.Hearing,
        },
        body: resources_1.UpdateHearingRequest,
        pathParams: zod_1.default.object({ hearingId: zod_1.default.string().uuid() }),
        summary: "Update a hearing's information",
    },
    deleteHearing: {
        method: 'DELETE',
        path: `${path}/:hearingId`,
        headers: resources_1.UserAuthHeadersSchema,
        responses: {
            [204]: zod_1.default.undefined(),
        },
        body: null,
        pathParams: zod_1.default.object({ hearingId: zod_1.default.string().uuid() }),
        summary: 'Delete a hearing and all hearing sections associated with it. May also delete the case if it is the last hearing associated with it.',
    },
}, {
    strictStatusCodes: true,
    validateResponseOnClient: true,
    commonResponses: (0, resources_1.errorResponses)(),
});
